module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002.4b9dac7.png";